const EMAIL_REGEXP = /^([a-zA-Z0-9.\-_]+)@[a-zA-Z0-9.\-_]+\.[a-zA-Z]{2,5}$/;

export default EMAIL_REGEXP;